import { useTranslation } from 'react-i18next'
import { FIRMWARE_TIMEOUT_MINUTES } from './firmwareTimeout'
import {
  FallbackField,
  FallbackLabel,
  FallbackInput,
  FallbackUnitRow,
  FallbackUnit,
} from './styles'

interface FirmwareTimeoutFieldProps {
  value: number | string | null
  onChange: (value: number | '') => void
}

export default function FirmwareTimeoutField({ value, onChange }: FirmwareTimeoutFieldProps) {
  const { t } = useTranslation()

  return (
    <FallbackField>
      <FallbackLabel>{t('node_sidebar.fallback_firmware_timeout_label')}</FallbackLabel>
      <FallbackUnitRow>
        <FallbackInput
          type="number"
          min={FIRMWARE_TIMEOUT_MINUTES.MIN}
          max={FIRMWARE_TIMEOUT_MINUTES.MAX}
          step="1"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value ? Number(e.target.value) : '')}
          placeholder={String(FIRMWARE_TIMEOUT_MINUTES.DEFAULT)}
          style={{ maxWidth: 80 }}
        />
        <FallbackUnit>{t('node_sidebar.minutes_unit')}</FallbackUnit>
      </FallbackUnitRow>
    </FallbackField>
  )
}
